/**
 * RoleManagementPage - RBAC role management dashboard
 *
 * Surfaces the RoleManagementDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides complete role management including JIT access, hierarchy visualization, and audit logs.
 *
 * Route: /admin/role-management
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';

import { RoleManagementDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function RoleManagementPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="violet">
            <IconLock size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Role Management</Title>
            <Text size="sm" c="dimmed">
              Complete RBAC management: roles, permissions, JIT access, and hierarchy
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <RoleManagementDashboard />
    </Container>
  );
}

export default RoleManagementPage;
